<div>
    <div class="d-flex align-items-center mb-2">
            <i class="fa fa-th-large red mr-2"></i>
            <div class="mr-2">{{ 'block_phone_number' | i18next }}
            </div>
    </div>
    <div class="ml-4">
        <div class="d-flex align-items-center">
            <div>{{ 'from' | i18next }}:</div>
            <div class="d-flex align-items-center ml-1 p-1 bg-light rounded">
                <span class="small">{{ numberFrom | phonenumber}}</span>
            </div>
        </div>

        <div class="d-flex align-items-center">
            <div>{{ 'to' | i18next }}:</div>
            <div class="d-flex align-items-center ml-1 p-1 bg-light rounded">
                <span class="small">{{ numberTo | phonenumber}}</span>
            </div>
        </div>
    </div>
</div>
